import { actionTypes } from "./storeTypes";

export const init_local = {
  oarvar: { rawdata: [] },
  oarFiltered: [],
  varFiltered: [],
  filter: {
    Ticker: [],
    ModelDate: [],
    Horizon: [],
    RiskModel:[],
    " Pctile ":[]
  },
  filterDefaults: {
    Ticker: [],
    ModelDate: [],
    Horizon: [],
    RiskModel:[],
    " Pctile ":[]
  },
  loading: true,
};

export function local_reducer(state, action) {
  switch (action.type) {
    case actionTypes.SET_OaRVaR: {
      return {
        ...state,
        oarvar: action.payload,
      };
    }
    case actionTypes.SET_OaR_FILTERED: {
      return {
        ...state,
        oarFiltered: action.payload,
      };
    }
    case actionTypes.SET_VaR_FILTERED: {
      return {
        ...state,
        varFiltered: action.payload,
      };
    }
    case actionTypes.SET_FILTER: {
      return {
        ...state,
        filter: action.payload,
      };
    }
    case actionTypes.SET_FILTER_DEFAULTS: {
      return {
        ...state,
        filterDefaults: action.payload,
      };
    }
    case actionTypes.SET_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    default:
      return state;
  }
}
